import angular from 'angular';
import tableGridRemoveCellComponent from './tableGridRemoveCell.component';

let tableGridRemoveCellModule = angular.module('tableGridRemoveCell', []).directive('tableGridRemoveCell', tableGridRemoveCellComponent);

export default tableGridRemoveCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridRemoveCell/tableGridRemoveCell.js